export const SET_LISTING_METADATA = 'lv3/SET_LISTING_METADATA';
export const SET_LISTING_METADATA_IS_LOADING = 'lv3/SET_LISTING_METADATA_IS_LOADING';
export const SET_LISTING_FILTERS = 'lv3/SET_LISTING_FILTERS';
export const SET_LISTING_FILTERS_IS_LOADING = 'lv3/SET_LISTING_FILTERS_IS_LOADING';
